import { z } from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const ClinicianTypeCodeEnum = z.string();
export type ClinicianTypeCode = LooseAutocomplete<'APHYSIO' | 'CONSULT' | 'PHYSIO'>;
